import React, { useState } from 'react';

import useToaster from '../../../../../../hooks/use-toaster/useToaster';

import Button from '../../../../../common/button/Button';
import TextInput from '../../../../../common/input/text-input/TextInput';
import Modal from '../../../../../common/modal/Modal';

import './accountability-configure-pass-name-modal.scss';

type Props = {
  show: boolean;
  close: () => void;
  onSaveClick: (name: string) => void;
};

const AccountabilityConfigurePassNameModal = ({ show, close, onSaveClick }: Props) => {
  const [name, setName] = useState('');

  const { showToaster } = useToaster();

  const closeModal = () => {
    setName('');
    close();
  };

  const handleSaveClick = () => {
    if (!name.trim()) {
      showToaster('error', 'Please enter a name');
      return;
    }

    onSaveClick(name);
    closeModal();
  };

  return (
    <Modal show={show}>
      <div className="accountability-configure-pass-name-modal">
        <div className="accountability-configure-pass-name-modal__header">Please Enter a Name</div>
        <div className="accountability-configure-pass-name-modal__content">
          <TextInput name="pass-name" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="accountability-configure-pass-name-modal__button-container">
          <Button text="Cancel" onClick={closeModal} />
          <Button text="Save" onClick={handleSaveClick} />
        </div>
      </div>
    </Modal>
  );
};

export default AccountabilityConfigurePassNameModal;
